module.exports = __webpack_public_path__ + "img/developers--icon.89efc8e0.svg";